"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const InterviewList_1 = __importDefault(require("./InterviewList"));
const ReviewStatusColumnFilter_1 = require("./ReviewStatusColumnFilter");
const InterviewCompletedFilter_1 = __importDefault(require("./InterviewCompletedFilter"));
const InterviewByCodeFilter_1 = __importDefault(require("./InterviewByCodeFilter"));
const InterviewByDateFilter_1 = __importDefault(require("./InterviewByDateFilter"));
const ValidationAuditFilter_1 = __importDefault(require("./ValidationAuditFilter"));
const InterviewByHomeGeographyFilter_1 = __importDefault(require("./InterviewByHomeGeographyFilter"));
const faTriangleExclamation_1 = require("@fortawesome/free-solid-svg-icons/faTriangleExclamation");
const faUserCircle_1 = require("@fortawesome/free-solid-svg-icons/faUserCircle");
const faEnvelope_1 = require("@fortawesome/free-solid-svg-icons/faEnvelope");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const errorHandling_1 = require("../../../services/errorManagement/errorHandling");
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const Status = __importStar(require("chaire-lib-common/lib/utils/Status"));
const useObjectReview_1 = require("../../../services/admin/useObjectReview");
const interviewListLiveStatus_1 = require("../../../services/admin/interviewListLiveStatus");
const InterviewListComponent = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['admin', 'main']);
    // We'll start our table without any data
    const [data, setData] = react_1.default.useState([]);
    const [loading, setLoading] = react_1.default.useState(false);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [pageCount, setPageCount] = react_1.default.useState(0);
    const fetchIdRef = react_1.default.useRef(0);
    // The rows are a snapshot taken when the list was fetched. Reviewing an interview beside the
    // list changes its status right away, so those changes are kept here and applied to the rows,
    // sparing the reviewer a page reload. They are kept for the whole visit: the reviewer sees
    // their own decisions, and reloads the page to see what the other reviewers did meanwhile.
    //
    // The store is what renders the list again: reviewing dispatches the decisions to
    // `state.survey.reviewDecisions`, subscribed to below, and marking complete updates
    // `state.survey.interview`, which arrives as `validationInterview`. The effect only records
    // what those renders show, so that a status outlives the fetch replacing the rows.
    const [liveStatusByUuid, setLiveStatusByUuid] = react_1.default.useState({});
    const reviewDecisionStatusByObject = (0, useObjectReview_1.useReviewDecisionStatusByObject)();
    const openInterviewStatus = (0, interviewListLiveStatus_1.getOpenInterviewStatus)(props.validationInterview, reviewDecisionStatusByObject);
    react_1.default.useEffect(() => {
        setLiveStatusByUuid((learned) => (0, interviewListLiveStatus_1.withLearnedInterviewStatus)(learned, openInterviewStatus));
    }, [openInterviewStatus === null || openInterviewStatus === void 0 ? void 0 : openInterviewStatus.uuid, openInterviewStatus === null || openInterviewStatus === void 0 ? void 0 : openInterviewStatus.review_status, openInterviewStatus === null || openInterviewStatus === void 0 ? void 0 : openInterviewStatus.is_completed]);
    const rows = react_1.default.useMemo(() => (0, interviewListLiveStatus_1.withLiveInterviewStatuses)(data, liveStatusByUuid), [data, liveStatusByUuid]);
    const batchAuditIdRef = react_1.default.useRef(0);
    const [batchAuditLoading, setBatchAuditLoading] = react_1.default.useState(false);
    const [batchAuditResult, setBatchAuditResult] = react_1.default.useState(null);
    const handleInterviewSummaryChange = (e) => {
        e.preventDefault();
        const uuid = e.target.getAttribute('data-uuid');
        if (!uuid) {
            return;
        }
        props.onInterviewSummaryChanged(uuid, e.target.getAttribute('data-prev-uuid') || undefined, e.target.getAttribute('data-next-uuid') || undefined);
    };
    // Helper function to build normalized data filters from filter array
    const buildFilters = (filters) => {
        const dataFilters = {};
        if (Array.isArray(filters)) {
            filters.forEach((filter) => {
                if (typeof filter.value === 'string' || Array.isArray(filter.value)) {
                    dataFilters[filter.id] = filter.value;
                }
                else if (typeof filter.value === 'object' && filter.value.value !== undefined) {
                    const { value, op } = filter.value;
                    dataFilters[filter.id] = { value, op };
                }
            });
        }
        return dataFilters;
    };
    // Function to fetch data from the server, with paging and filtering
    const fetchData = react_1.default.useCallback((_a) => __awaiter(void 0, [_a], void 0, function* ({ pageSize, pageIndex, filters, sortBy }) {
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current;
        // Set the loading state
        setLoading(true);
        // Make a query string from the filters
        const dataFilters = buildFilters(filters);
        try {
            const response = yield fetch('/api/validationList', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify(Object.assign({ pageSize,
                    pageIndex,
                    sortBy }, dataFilters))
            });
            if (fetchId !== fetchIdRef.current) {
                // There was another query since, ignore
                return;
            }
            if (response.status === 200) {
                const jsonData = yield response.json();
                if (fetchId !== fetchIdRef.current) {
                    // Reading the body took long enough for another query to answer, ignore
                    return;
                }
                const data = jsonData.interviews ? jsonData.interviews : [];
                const [totalCount, pageCount] = jsonData.totalCount
                    ? [jsonData.totalCount, Math.ceil(jsonData.totalCount / pageSize)]
                    : [0, 0];
                setData(data);
                setPageCount(pageCount);
                setTotalCount(totalCount);
            }
            else {
                console.error('Invalid response code from server: ', response.status);
                (0, errorHandling_1.handleHttpOtherResponseCode)(response.status, props.dispatch);
            }
        }
        catch (error) {
            console.error(`Error fetching user data from server: ${error}`);
            setData([]);
            setTotalCount(0);
        }
        finally {
            if (fetchId === fetchIdRef.current) {
                setLoading(false);
            }
        }
    }), []);
    // Function to run batch audits on filtered interviews
    const runBatchAudits = react_1.default.useCallback((extended, currentFilters, currentPageIndex, currentPageSize, currentSortBy) => __awaiter(void 0, void 0, void 0, function* () {
        // Give this batch audit request an ID
        const batchAuditId = ++batchAuditIdRef.current;
        setBatchAuditLoading(true);
        setBatchAuditResult(null);
        // Make a query string from the filters (same as fetchData)
        const dataFilters = buildFilters(currentFilters);
        try {
            const response = yield fetch('/api/validation/batchAudits', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify(Object.assign({ extended }, dataFilters))
            });
            if (batchAuditId !== batchAuditIdRef.current) {
                // There was another batch audit request since, ignore this result
                return;
            }
            if (response.status === 200) {
                const jsonData = yield response.json();
                setBatchAuditResult(Status.createOk({
                    totalCount: jsonData.totalCount || 0,
                    processed: jsonData.processed || 0,
                    succeeded: jsonData.succeeded || 0,
                    failed: jsonData.failed || 0
                }));
                // Refresh the list after batch audit using current table state
                yield fetchData({
                    pageSize: currentPageSize,
                    pageIndex: currentPageIndex,
                    filters: currentFilters,
                    sortBy: currentSortBy
                });
            }
            else {
                console.error('Invalid response code from server: ', response.status);
                (0, errorHandling_1.handleHttpOtherResponseCode)(response.status, props.dispatch);
                const errorMessage = `Invalid response code: ${response.status}`;
                setBatchAuditResult(Status.createError(errorMessage));
            }
        }
        catch (error) {
            console.error(`Error running batch audits: ${error}`);
            if (batchAuditId === batchAuditIdRef.current) {
                const errorMessage = error instanceof Error ? error.message : String(error);
                setBatchAuditResult(Status.createError(errorMessage));
            }
        }
        finally {
            setBatchAuditLoading(false);
        }
    }), [fetchData, props.dispatch]);
    // TODO: Turn cells into proper components instead of just making them inline.
    const columns = react_1.default.useMemo(() => {
        const columns = [
            {
                accessor: 'id',
                label: t('admin:InterviewId'),
                Cell: ({ value }) => `#${value}`,
                enableSortBy: true
            },
            ...(project_config_1.default.hasAccessCode
                ? [
                    {
                        id: 'response.accessCode',
                        label: t('admin:interviewByCodeFilter:title'),
                        accessor: 'response.accessCode',
                        Filter: InterviewByCodeFilter_1.default,
                        enableSortBy: true
                    }
                ]
                : []),
            {
                id: 'created_at',
                accessor: 'created_at',
                label: t('admin:interviewByDateFilter:title'),
                Cell: ({ value }) => !(0, LodashExtensions_1._isBlank)(value) ? new Date(value).toISOString().split('T')[0].replace('/', '-') : '?', // Converts to YYYY-MM-DD format
                Filter: InterviewByDateFilter_1.default,
                enableSortBy: true
            },
            {
                // The completion the participant reached in the questionnaire, which is not the
                // `is_completed` flag the reviewer sets from the top menu and which colors the
                // row. The two are distinct, so this column does not follow a live review either.
                accessor: 'response._isCompleted',
                Filter: InterviewCompletedFilter_1.default,
                enableSortBy: false,
                Cell: ({ value }) => value ? t('admin:CompletedFemSingular') : t('admin:NotCompletedFemSingular')
            },
            {
                accessor: 'review_status',
                Filter: ReviewStatusColumnFilter_1.ReviewStatusColumnFilter,
                Cell: ({ value }) => t(`admin:reviewStatus:${value}`)
            },
            {
                accessor: 'response.household.size',
                Cell: ({ value }) => (react_1.default.createElement(react_1.default.Fragment, null,
                    value || '?',
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faUserCircle_1.faUserCircle, className: "faIconNoMargin", 
                        /* eslint-disable-next-line react/prop-types */
                        title: t('admin:persons') }))),
                label: t('admin:HouseholdSize'),
                enableSortBy: true
            },
            {
                accessor: 'audits',
                Cell: ({ value }) => !value || Object.keys(value).length === 0 ? ('') : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faTriangleExclamation_1.faTriangleExclamation, className: "faIconNoMargin _error _red", title: Object.keys(value)
                        /* eslint-disable-next-line react/prop-types */
                        .map((error) => t([`survey:validations:${error}`, `surveyAdmin:${error}`]))
                        .join('\n') })),
                Filter: ValidationAuditFilter_1.default
            },
            {
                accessor: 'uuid',
                Cell: ({ data, row, value }) => {
                    // TODO Do we want to continue navigating beyond the current page? If so, implement it
                    const prevUuid = row.index > 0 ? data[row.index - 1].uuid : '';
                    const nextUuid = row.index < data.length - 1 ? data[row.index + 1].uuid : '';
                    return (react_1.default.createElement("a", { href: "", id: `interviewButtonList_${value}`, "data-uuid": value, "data-prev-uuid": prevUuid, "data-next-uuid": nextUuid, onClick: handleInterviewSummaryChange }, t('admin:Correct') /* eslint-disable-line react/prop-types */));
                }
            },
            {
                accessor: 'response._validationComment',
                Cell: ({ value }) => (0, LodashExtensions_1._isBlank)(value) ? ('') : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faEnvelope_1.faEnvelope, className: "faIconNoMargin", title: value }))
            },
            {
                accessor: 'response.home.geography',
                label: t('admin:interviewByHomeGeographyFilter:Title'),
                Cell: () => '',
                Filter: InterviewByHomeGeographyFilter_1.default,
                enableSortBy: false
            }
        ];
        return columns;
    }, []);
    return (react_1.default.createElement(InterviewList_1.default, { showInterviewList: props.showInterviewList, validationInterview: props.validationInterview, interviewListChange: props.interviewListChange, columns: columns, data: rows, fetchData: fetchData, loading: loading, pageCount: pageCount, itemCount: totalCount, initialSortBy: props.initialSortBy, runBatchAudits: runBatchAudits, batchAuditLoading: batchAuditLoading, batchAuditResult: batchAuditResult }));
};
const mapDispatchToProps = (dispatch, _props) => ({
    dispatch
});
exports.default = (0, react_redux_1.connect)(undefined, mapDispatchToProps)(InterviewListComponent);
//# sourceMappingURL=InterviewListComponent.js.map